// Função para formatar valores monetários em formato BRL
export const formatBRL = (value) => {
  if (value === undefined || value === null) return "-";
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

// Função para formatar números com duas casas decimais
export const formatNumber = (value, decimals = 2) => {
  if (value === undefined || value === null) return "-";
  
  // Se for uma string, converte para número
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Verifica se o número é muito grande ou tem muitos decimais
  const decimalStr = numValue.toString().split('.')[1] || '';
  
  // Se tiver muitos dígitos decimais, limita-os
  if (decimalStr.length > 8) {
    return parseFloat(numValue.toFixed(2)).toLocaleString('pt-BR');
  }
  
  // Para números normais, usa a formatação padrão
  return parseFloat(numValue.toFixed(decimals)).toLocaleString('pt-BR');
};

// Função para formatar porcentagem
export const formatPercent = (value) => {
  if (value === undefined || value === null) return "-";
  return `${formatNumber(value, 1)}%`;
};

// Função para formatar horas
export const formatHours = (value) => {
  if (value === undefined || value === null) return "-";
  // Arredonda para uma casa decimal se for um número grande
  if (value > 100) {
    return `${Number(value).toFixed(1).replace('.', ',')} horas`;
  }
  // Para valores menores, permite duas casas decimais
  return `${Number(value).toFixed(2).replace('.', ',')} horas`;
};

// Função para formatar dias
export const formatDays = (value) => {
  if (value === undefined || value === null) return "-";
  if (value < 1) {
    return `${Math.round(value * 24)} horas`;
  }
  return `${Number(value).toFixed(1).replace('.', ',')} dias`;
};

// Função para converter períodos selecionados em datas
export const periodoToDates = {
  "7dias": () => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 7);
    return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
  },
  "30dias": () => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 30);
    return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
  },
  "90dias": () => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 90);
    return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
  },
  "365dias": () => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 365);
    return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
  },
  // Valor temporário para forçar refetch
  "temp_refresh": () => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 30); // Padrão de 30 dias
    return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
  },
};
